module.exports = __webpack_public_path__ + "img/user-invalid.c0f26db9.svg";